import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  TextField,
  Grid,
  Paper,
  Typography,
  MenuItem,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Divider,
  Box,
} from "@mui/material";
import {
  checkListDocSubmit,
  empChecklistSubmit,
  getCheckListForEmp,
} from "../../api/resignationCheckliistAssign";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../config/action-config";

import { getEmployees } from "../../../src/api/employee";
import { useNavigate } from "react-router-dom";
import { showAlert } from "../../actions/alert";
const keysToRemove = ["status", "created_by", "document_path"];
export default function EmployeeKTChecklist() {
  // State variables
  const navigate = useNavigate();
  const [projectsArray, setProjectArray] = useState([]);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const ref = useRef();
  const [projectsList, setProjectsList] = useState([]);
  const [docCompletion, setDocCompletion] = useState(false);
  const [docUplod, setDocUpload] = useState({
    index: "",
    status: false,
  });
  const [ktAssignedDate, setKtAssignedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [formData, setFormData] = useState();

  const [ktCompletionDate, setKtCompletionDate] = useState("");
  const [documentationCompleted, setDocumentationCompleted] = useState("");
  const [documentationRemarks, setDocumentationRemarks] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [employeeList, setempList] = useState([]);

  // useEffect to fetch project data on component mount
  useEffect(() => {
    getProjectData();

    // getEmployeeListDetail();
    // getDocuments()
  }, [user.resignation_initiated]);

  // async function getDocuments(){
  //   try{
  //     const{data}=await checkListDocSubmit(user.token);
  //   }
  //   catch (error) {
  //     handleAxiosError(error, dispatch);
  //   }
  // }
  const handleimageUpload = async (event, id, index) => {
    const file = event.target.files?.[0];
    const formData = new FormData();
    formData.append("document_id", id);
    formData.append("files", file);
    try {
      const { data } = await checkListDocSubmit(formData, user.token);
      console.log(data.Uploadedfilename, "Uploadedfilename");
      if (data.status) {
        console.log(data, "data");
        projectsArray?.map((el) => {
          projectsArray[index].document_path = data.uploadedFilePath;
          projectsArray[index].document_file = data.Uploadedfilename;
        });

        setProjectArray([...projectsArray]);
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  async function getProjectData() {
    try {
      const { data } = await getCheckListForEmp(user.token);
      if (data.data === 0) {
        dispatch(showAlert(data.msg));
      } else {
        let projects = [];
        setProjectArray([...data.data]);
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  // Function to handle documentation completion change
  const handleDocumentationCompletedChange = (event) => {
    setDocumentationCompleted(event.target.value);
  };

  // async function getEmployeeListDetail(){
  //   try{
  //        const {data}=await getEmployees({limit:"",offset:"",},user.token)
  //        console.log(data,"data")
  //        setempList([...data.data])
  //   }catch(error){
  //     handleAxiosError(error, dispatch);

  //   }
  // }

  const onFormChange = (event, index) => {
    const { name, value } = event.target;
    if (name === "handover_to") {
      projectsArray?.map((el) => {
        projectsArray[index].handover_to = value;
      });
    }
    if (name === "assign_date") {
      projectsArray?.map((el) => {
        projectsArray[index].assign_date = value;
      });
    }
    if (name === "completion_date") {
      projectsArray?.map((el) => {
        projectsArray[index].completion_date = value;
      });
    }
    if (name === "document_completion") {
      projectsArray?.map((el) => {
        setDocUpload({ status: value, index: index });

        projectsArray[index].document_completion = value;
      });
    }
    if (name === "documentation_remarks") {
      projectsArray?.map((el) => {
        projectsArray[index].documentation_remarks = value;
      });
    }
    setProjectArray([...projectsArray]);
  };

  async function getEmployeeListDetail() {
    try {
      const { data } = await getEmployees(
        { limit: "", offset: "" },
        user.token
      );
      console.log(data, "data");
      setempList([...data.data]);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    let Formdata = {
      ...formData,
      data: filterKeysAndRemove(projectsArray),
    };
    try {
      const { data } = await empChecklistSubmit(Formdata, user.token);
      dispatch(showAlert(data.msg));
      getProjectData();
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  console.log(projectsArray, "projectsArray");
  return (
    <Paper elevation={3} style={{ padding: 20 }}>
      {projectsArray.map((e, index) => (
        <Box
          key={index}
          sx={{
            border: 2,
            borderColor: "primary.main",
            borderRadius: 5,
            p: 2,
            mb: 2,
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h8"
              style={{ fontWeight: "bold", color: "#08459c" }}
            >
              Project Name:{e.project_name}
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Project Name"
                value={e.project_name} // Assuming the default value is empty
                onChange={(e) => onFormChange(e, index)}
              ></TextField>
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="handover_to"
                label="KT Handover To"
                onChange={(e) => onFormChange(e, index)}
                value={e.handover_to}
              >
                {/* {

                onChange={(e) => onFormChange(e, index)}
                // select
                value={e.handover_to}
              >
                {/* {

                  employeeList?.map((el,i)=>{
                    // console.log(el,"cjs")
                   return (
                  
                    <MenuItem key={i} value={el.firstname +" "+ el.lastname}>{el.firstname +" "+ el.lastname}</MenuItem>
                    
                  )})
                } */}
              </TextField>
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Assigned Date"
                type="date"
                name="assign_date"
                InputLabelProps={{ shrink: true }}
                value={e?.assign_date ? e?.assign_date.substring(0, 10) : ""}
                onChange={(e) => onFormChange(e, index)}
                disabled
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Completion Date"
                type="date"
                name="completion_date"
                InputLabelProps={{ shrink: true }}
                value={
                  e?.completion_date ? e.completion_date.substring(0, 10) : ""
                }
                onChange={(e) => onFormChange(e, index)}
                disabled
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl>
                <Typography variant="subtitle1">
                  Documentation Completed
                </Typography>
                <RadioGroup
                  row
                  aria-label="documentation-completed"
                  name="document_completion"
                  value={e.document_completion}
                  onChange={(e) => {
                    onFormChange(e, index);
                    setDocCompletion(e.document_completion);
                  }}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {e.document_completion === "true" ||
            (docUplod.index.toString() === index.toString() &&
              docUplod.status === "true") ? (
              <Grid item xs={3}>
                <input
                  ref={ref}
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  style={{ display: "none" }}
                  id={`raised-button-file${index}`}
                  // multiple
                  type="file"
                  onChange={(ev) => handleimageUpload(ev, e.id, index)}
                />
                <label htmlFor={`raised-button-file${index}`}>
                  <Button variant="outlined" component="span">
                    Upload Documentation
                  </Button>
                </label>
                <Typography variant="body1" style={{ marginLeft: 10 }}>
                  {e?.document_file}
                </Typography>
                {e?.document_file ? null : (
                  <p className="para">
                    *Kindly upload single PDF file only No multifile file will
                    be accepted
                  </p>
                )}
              </Grid>
            ) : null}
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Documentation Remarks"
                multiline
                name="documentation_remarks"
                value={e.documentation_remarks}
                onChange={(e) => onFormChange(e, index)}
              />
            </Grid>
            {/* <Grid item xs={3}>
              {e?.document_file?
            <Link to="#"><Button variant="outlined" component="span">
                  Document Preview
                </Button></Link>
                :null
              }
                </Grid> */}

            <Grid item xs={12}>
              <Divider /> {/* Add Divider component */}
            </Grid>
          </Grid>
        </Box>
      ))}
      {projectsArray.length !== 0 && (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              columnGap: 1,
              ml: "auto",
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                navigate("/profile");
              }}
              className="blue-button"
            >
              CANCEL
            </Button>
            {projectsArray[0].status === "KT_APPROVED" ||
            projectsArray[0].status === "SUBMITTED" ? (
              <></>
            ) : (
              <Button
                variant="contained"
                disabled={
                  projectsArray[0].status === "KT_APPROVED" ||
                  projectsArray[0].status === "SUBMITTED"
                    ? true
                    : false
                }
                // onClick={handleSubmit(onLeaveUpdate)}
                type="submit"
                style={{ padding: "5px 7px" }}
                className="blue-button"
                onClick={onSubmit}
              >
                SUBMIT
              </Button>
            )}
          </Box>
        </Grid>
      )}
    </Paper>
  );
}
function filterKeysAndRemove(array) {
  return array.map((obj) => {
    const filteredObj = { ...obj };
    keysToRemove.forEach((key) => {
      delete filteredObj[key];
    });
    return filteredObj;
  });
}
